import { getAnonId } from '@/utils/anonId';
import { validateEnv } from '@/utils/validateEnv';
import flagsmith from '@flagsmith/flagsmith';

let initPromise: Promise<void> | null = null;

export const initFlagsmith = (): Promise<void> => {
  if (initPromise) return initPromise;
  initPromise = flagsmith
    .init({
      environmentID: validateEnv().VITE_FLAGSMITH_TOKEN,
      identity: getAnonId(),
      cacheFlags: true,
      enableAnalytics: true,
    })
    .catch((err) => {
      initPromise = null;
      console.error(err);
    });

  return initPromise;
};
